<template>
  <Select
    ref="selectRef"
    :model-value="modelValue"
    :options="options"
    compact
    aria-label="Rows per page"
    @update:model-value="handleUpdate"
  />
</template>

<script setup lang="ts">
import { nextTick, onBeforeUnmount, ref } from 'vue';

import Select from '@/components/ui/select/Select.vue';
import type { SelectOption } from '@/components/ui/select/Select';
import { applyDataTablesPageLength } from '@/modules/shipments/utils/data-tables-page-length';

const props = defineProps<{
  select: HTMLSelectElement;
  options: SelectOption[];
}>();

const modelValue = ref(props.select.value);
const selectRef = ref<InstanceType<typeof Select> | null>(null);

function syncFromNativeSelect(): void {
  modelValue.value = props.select.value;
}

props.select.addEventListener('change', syncFromNativeSelect);

onBeforeUnmount(() => {
  props.select.removeEventListener('change', syncFromNativeSelect);
});

function handleUpdate(value: string): void {
  selectRef.value?.forceCloseMenu();
  modelValue.value = value;

  void nextTick(() => {
    if (!applyDataTablesPageLength(props.select, value) && props.select.value !== value) {
      props.select.value = value;
      props.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}
</script>
